export const PAYPAL_POS_SALES_CHANNEL_TYPE_ID = '1ce0868f406d47d98cfe4b281e62f099';
export const PAYPAL_POS_SALES_CHANNEL_EXTENSION = 'paypalPosSalesChannel';

export default {
    PAYPAL_POS_SALES_CHANNEL_TYPE_ID,
    PAYPAL_POS_SALES_CHANNEL_EXTENSION,
};
